import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import ListingsSearchCriteriaSurvey from "./ListingsSearchCriteriaSurvey";
import MiniApp from "./miniapp/MiniApp";

const App: React.FC = () => {

    return (
        <Router>
            <Routes>
                <Route path="/survey" element={<ListingsSearchCriteriaSurvey/>}/>
                <Route path="/surveyV2" element={<ListingsSearchCriteriaSurvey/>}/>
                <Route path="/miniapp/*" element={<MiniApp/>}/>
            </Routes>
        </Router>
    );
};

export default App;